import Vue from 'vue'
import Router from 'vue-router'
import Accueil from './views/Accueil.vue'
import MiniSite from './views/MiniSite.vue'
import APropos from './views/APropos.vue'
import Ussd from './views/Ussd.vue'
import Tarif from './views/Tarif.vue'
import Faq from './views/Faq.vue'
import Evenement from './views/Evenement.vue'
import Avantage from './views/Avantage.vue'

Vue.use(Router)

export default new Router({
  //mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'accueil',
      component: Accueil
    },
    {
      path: '/evenement/:type',
      name: 'evenement',
      component: Evenement,
      props : true
    },
    {
      path: '/minisite/:evenementId',
      name: 'minisite',
      component: MiniSite,
      props : true
    },
    {
      path: '/apropos',
      name: 'apropos',
      component: APropos
    },
    {
      path: '/avantage',
      name: 'avantage',
      component: Avantage
    },
    {
      path: '/ussd',
      name: 'ussd',
      component: Ussd
    },
    {
      path: '/tarif',
      name: 'tarif',
      component: Tarif
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ],
  scrollBehavior (to, from, saved) {
    if (saved) { 
      return saved 
    } else if (to.hash) { 
      return false 
    } else { 
      return { x: 0, y: 0 } 
    } 
  }
})
